import { render, staticRenderFns } from "./WorkshopGroupUserListModal.vue?vue&type=template&id=b343ef2c&"
import script from "./WorkshopGroupUserListModal.vue?vue&type=script&lang=js&"
export * from "./WorkshopGroupUserListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports